(function () {
  function getSelectedOption(select) {
    return (select.selectedOptions && select.selectedOptions[0])
      ? select.selectedOptions[0]
      : select.options[select.selectedIndex];
  }
  // Fallback para Shopify.formatMoney si no existe
  if (typeof window.Shopify === 'undefined') {
    window.Shopify = {};
  }
  if (typeof Shopify.formatMoney !== 'function') {
    Shopify.formatMoney = function(cents, format) {
      var value = (cents / 100).toFixed(2);
      return format.replace('{{amount}}', value);
    };
  }
  function updateCard(selectEl) {
    const option = getSelectedOption(selectEl);
    if (!option) return;
    const card = selectEl.closest('.product-card');
    if (!card) return;
    const pid = selectEl.dataset.productId || card.dataset.productId;
    const hasProductDiscount = card.dataset.hasProductDiscount === 'true';
    const productDiscount = parseInt(card.dataset.productDiscount) || 0;
    const hasCollectionDiscount = card.dataset.hasCollectionDiscount === 'true';
    const collectionDiscount = parseInt(card.dataset.collectionDiscount) || 0;
    const priceBox = card.querySelector(`#ProductPrice-${pid}`) || card.querySelector('[data-role="product-price"]');
    if (priceBox) {
      const priceCents = parseInt(option.dataset.price, 10);
      const price = isNaN(priceCents) ? 0 : priceCents;
      const moneyFormat = (window.theme && window.theme.money_format)
        ? window.theme.money_format
        : "€{{amount}}";
      const normalPrice = Shopify.formatMoney(price, moneyFormat);
      const suffix = ' /ud <span class="f-price__tax">IVA&nbsp;incl.</span>';
      if (price === 0) {
        priceBox.innerHTML = '<span class="consult-price text-lg font-semibold">Consultar&nbsp;precio</span>';
      } else if (hasProductDiscount || hasCollectionDiscount) {
        const discountPercentage = hasProductDiscount ? productDiscount : collectionDiscount;
        const discountMultiplier = (100 - discountPercentage) / 100;
        const discountedPrice = Math.round(price * discountMultiplier);
        const discountedPriceFormatted = Shopify.formatMoney(discountedPrice, moneyFormat);
        priceBox.innerHTML = `<span class="compare-at-price line-through text-subtext mr-2" style="color: #C4301C">${normalPrice}</span><span class="current-price text-lg font-semibold">${discountedPriceFormatted}${suffix}</span>`;
      } else {
        priceBox.innerHTML = `<span class="current-price text-lg font-semibold">${normalPrice}${suffix}</span>`;
      }
    }
    const imgEl =
      card.querySelector(`#ProductImage-${pid}`) ||
      card.querySelector(`#ProductImage-${pid} img`) ||
      card.querySelector('[data-role="product-image"] img') ||
      card.querySelector('[data-role="product-image"]');
    if (imgEl && option.dataset.image) {
      imgEl.src = option.dataset.image;
      imgEl.srcset = option.dataset.image;
    }
    const qty = card.querySelector('.quantity__input');
    if (qty) {
      const units = parseInt(option.dataset.units || 1, 10);
      qty.value = units;
      qty.min = units;
      qty.step = units;
    }
    const idInput = card.querySelector('input[name="id"]');
    if (idInput) idInput.value = option.value;
    const atc = card.querySelector('button[type="submit"]');
    if (atc) atc.disabled = option.dataset.available !== 'true';
    
    // Actualizar la etiqueta de Stock
    const badgeContainer = card.querySelector('.product-card__badge');
    if (badgeContainer) {
      // Solo manipular la badge de stock
      // Elimina solo los elementos con la clase exacta f-badge--stock
      let stockBadges = badgeContainer.querySelectorAll('.f-badge.f-badge--stock');
      const inventoryQty = parseInt(option.dataset.inventory_quantity, 10);
      if (inventoryQty > 0) {
        // Elimina todas las badges de stock previas antes de crear una nueva
        stockBadges.forEach(badge => badgeContainer.removeChild(badge));
        // Crear la badge de stock
        const stockBadge = document.createElement('span');
        stockBadge.className = 'f-badge f-badge--stock';
        stockBadge.setAttribute('aria-hidden', 'true');
        stockBadge.textContent = 'Stock';
        badgeContainer.appendChild(stockBadge);
      } else {
        // Elimina todas las badges de stock si existen
        stockBadges.forEach(badge => badgeContainer.removeChild(badge));
      }
    }
  }
  document.addEventListener('change', (e) => {
    if (e.target.matches('.variant-selector')) {
      updateCard(e.target);
    }
  });
  document.addEventListener('input', (e) => {
    if (e.target.matches('.variant-selector')) {
      updateCard(e.target);
    }
  });
  window.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.variant-selector').forEach((sel) => updateCard(sel));
  });
  
  // Permite re-inicializar las cards tras AJAX
  window.initProductCards = function() {
    document.querySelectorAll('.variant-selector').forEach((sel) => updateCard(sel));
  };
})();